import { useState } from 'react';

import List from 'components/List';
import { useAuth } from 'contexts/auth';
import { Fields } from 'types/table';

export const getFazendaFields = async (field: any, selectedFazenda: any): Promise<Fields[]> => {
  return [
    {
      name: 'CodFazenda',
      label: 'Código da Fazenda',
      type: 'text',
      defaultValue: field?.codFazenda,
      sm: 6,
      md: 4,
    },
    {
      name: 'CodCentro',
      label: 'Código do Centro',
      type: 'text',
      defaultValue: field?.CodCentro,
      sm: 6,
      md: 4,
    },
    {
      name: 'CodProdutor',
      label: 'Código do Produtor',
      type: 'text',
      defaultValue: field?.CodProdutor,
      sm: 6,
      md: 4,
    },
    {
      name: 'ATIVO',
      label: 'Ativo',
      type: 'checkbox',
      defaultValue: field?.ATIVO,
      sm: 6,
      md: 4,
    },
    {
      name: 'LastSend',
      label: 'Último Envio',
      type: 'date',
      defaultValue: field?.LastSend,
      sm: 6,
      md: 4,
    },
  ];
};

export default function Fazendas() {
  const { selectedFazenda } = useAuth();
  const [fazenda, setFazenda] = useState({} as any);

  return (
    <div>
      <List
        title="Fazendas"
        table="fazenda"
        idColumn="CodFazenda"
        setSelected={setFazenda}
        selected={fazenda}
        columns={[
          { title: 'Código da Fazenda', field: 'CodFazenda' },
          { title: 'Código do Centro', field: 'CodCentro' },
          { title: 'Código do Produtor', field: 'CodProdutor' },
          { title: 'Ativo', field: 'ATIVO' },
          {
            title: 'Último Envio',
            field: 'LastSend',
            render: (rowData) => {
              const date = new Date(rowData.LastSend);
              return date.toLocaleDateString();
            },
          },
        ]}
        data={`fazendas/getByFazenda/${selectedFazenda.codFazenda}`}
        getFields={getFazendaFields}
      />
    </div>
  );
}
